<template>
    <div class="favorite-flats-crm">
        <flatsItems :flatsArr="dataItems" v-if="dataItems != null"></flatsItems>
        <div class="empty-msg-container" v-if="pageSetup != null && dataItems == null && empty">
            <h2>{{ pageSetup.empty_favorite_flats.msg }}</h2>
            <div class="instructions">
                <h3>{{ pageSetup.empty_favorite_flats.info.title }}</h3>
                <ul>
                    <li v-for="(item, index) in pageSetup.empty_favorite_flats.info.steps">
                        <span class="num">{{ index + 1}}</span>
                        <p v-if="index != 1" v-html="item.desc"></p>
                        <p v-else>
                            <span>{{ getCorrectStr(item.desc, 1) }}</span>
                            <svgIcon name="star-sales" class="icon-star"/>
                            <span> {{ getCorrectStr(item.desc, 2) }}</span>
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
	import flatsItems from '@/components/flats-crm/flats-crm-items-favorite.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'favorite-flats',
        components: {
            flatsItems,
            svgIcon,
        },
        data () {
            return {
                title: 'Квартиры',
                empty: false,
                dataItems: null,
                dataResp: {
                    "apartmentIds": null,
                }
            }
        },
        computed: mapGetters({
            pageSetup: 'loadFavoritePage',
        }),
        methods: {
            getFavoriteFlats() {
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                if (exist.length > 0) {
                    // шлюз принимает до 100 id за запрос; берём последние добавленные
                    this.dataResp.apartmentIds = exist.slice(-100);
                    axios.post(window.CRMProxy + '/v1/apartments', this.dataResp).then(async (response) => {
                        if (response.data.data.length != 0) {
                            this.dataItems = response.data.data;
                        } else {
                            this.empty = true;
                        }
                    }).catch(() => {
                        this.empty = true;
                    });
                } else {
                    this.empty = true;
                }
            },
            getCorrectStr(str, index) {
                var clearStr;
                if (index == 1) {
                    clearStr = str.split("<span>")[0];
                    return clearStr;
                } else {
                    clearStr = str.split("<span>")[1].replace('</span>', '');
                    return clearStr;   
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.projectItems != null) {
                next(vm => {
                    vm.getFavoriteFlats();
                    vm.$parent.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getProjectsItems').then((response) => {
                    if (response) {
                        next(vm => {
                            vm.getFavoriteFlats();
                            vm.$parent.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
        },
        created () {
            this.$store.commit('setCustomCrumb', this.title);
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-favorite.scss';
</style>